import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { PaymentElement } from '@stripe/react-stripe-js';

import { DisplayText, theme } from '@sg/garnish';

import { type StripePaymentElementProps } from '../../types';

// ────────────────────────────────────────────────────────────────────────────

export const StripePaymentElement = (props: StripePaymentElementProps) => {
  const { children, show } = props;

  return (
    <View style={[styles.container, show ? null : styles.hide]}>
      <DisplayText sizeMatch={['32']}>
        <FormattedMessage {...messages.title} />
      </DisplayText>

      <PaymentElement />

      {children}
    </View>
  );
};

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    padding: theme.spacing['4'],
    paddingTop: theme.spacing['20'],
    paddingBottom: theme.spacing['10'],
    gap: theme.spacing['4'],
  },
  hide: {
    maxHeight: 0,
    paddingTop: 0,
    paddingBottom: 0,
  },
});

// ─── Messages ───────────────────────────────────────────────────────────────

const messages = defineMessages({
  title: {
    defaultMessage: 'Select payment option',
    description: 'Stripe Payment Element | Title',
  },
});
